import {
  createCategory as publicCreateCategory,
  deleteCategory as publicDeleteCategory,
  updateCategory as publicUpdateCategory,
  getCategory as publicGetCategory,
  enterpriseOnboarding as publicEnterpriseOnboarding,
  getMediaManagerCategories as publicGetMediaManagerCategories,
} from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.public.js';
import { createRESTModule } from '@wix/sdk-runtime/rest-modules';
import { createEventModule } from '@wix/sdk-runtime/event-definition-modules';
import {
  BuildRESTFunction,
  MaybeContext,
  BuildEventDefinition,
} from '@wix/sdk-types';
import { onEnterpriseCategoryCreated as publicOnEnterpriseCategoryCreated } from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.public.js';
import { onEnterpriseCategoryDeleted as publicOnEnterpriseCategoryDeleted } from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.public.js';
import { onEnterpriseCategoryUpdated as publicOnEnterpriseCategoryUpdated } from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.public.js';

export const createCategory: MaybeContext<
  BuildRESTFunction<typeof publicCreateCategory> & typeof publicCreateCategory
> = /*#__PURE__*/ createRESTModule(publicCreateCategory);
export const deleteCategory: MaybeContext<
  BuildRESTFunction<typeof publicDeleteCategory> & typeof publicDeleteCategory
> = /*#__PURE__*/ createRESTModule(publicDeleteCategory);
export const updateCategory: MaybeContext<
  BuildRESTFunction<typeof publicUpdateCategory> & typeof publicUpdateCategory
> = /*#__PURE__*/ createRESTModule(publicUpdateCategory);
export const getCategory: MaybeContext<
  BuildRESTFunction<typeof publicGetCategory> & typeof publicGetCategory
> = /*#__PURE__*/ createRESTModule(publicGetCategory);
export const enterpriseOnboarding: MaybeContext<
  BuildRESTFunction<typeof publicEnterpriseOnboarding> &
    typeof publicEnterpriseOnboarding
> = /*#__PURE__*/ createRESTModule(publicEnterpriseOnboarding);
export const getMediaManagerCategories: MaybeContext<
  BuildRESTFunction<typeof publicGetMediaManagerCategories> &
    typeof publicGetMediaManagerCategories
> = /*#__PURE__*/ createRESTModule(publicGetMediaManagerCategories);
/**
 * Triggered when a category is created.
 */
export const onEnterpriseCategoryCreated: BuildEventDefinition<
  typeof publicOnEnterpriseCategoryCreated
> &
  typeof publicOnEnterpriseCategoryCreated = createEventModule(
  publicOnEnterpriseCategoryCreated
);
/**
 * Triggered when a category is deleted.
 */
export const onEnterpriseCategoryDeleted: BuildEventDefinition<
  typeof publicOnEnterpriseCategoryDeleted
> &
  typeof publicOnEnterpriseCategoryDeleted = createEventModule(
  publicOnEnterpriseCategoryDeleted
);
/**
 * Triggered when a category is updated.
 */
export const onEnterpriseCategoryUpdated: BuildEventDefinition<
  typeof publicOnEnterpriseCategoryUpdated
> &
  typeof publicOnEnterpriseCategoryUpdated = createEventModule(
  publicOnEnterpriseCategoryUpdated
);

export {
  PublishStatus,
  MediaType,
  WebhookIdentityType,
} from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.universal.js';
export {
  EnterpriseCategory,
  CreateCategoryRequest,
  CreateCategoryResponse,
  DeleteCategoryRequest,
  DeleteCategoryResponse,
  UpdateCategoryRequest,
  UpdateCategoryResponse,
  GetCategoryRequest,
  GetCategoryResponse,
  EnterpriseCategoryTree,
  EnterpriseOnboardingRequest,
  EnterpriseOnboardingResponse,
  LinkItemsToCategoryRequest,
  LinkItemsToCategoryResponse,
  UnlinkItemsFromCategoryRequest,
  UnlinkItemsFromCategoryResponse,
  GetMediaManagerCategoriesRequest,
  GetMediaManagerCategoriesResponse,
  DomainEvent,
  DomainEventBodyOneOf,
  EntityCreatedEvent,
  RestoreInfo,
  EntityUpdatedEvent,
  EntityDeletedEvent,
  ActionEvent,
  MessageEnvelope,
  IdentificationData,
  IdentificationDataIdOneOf,
  AccountInfo,
  BaseEventMetadata,
  EventMetadata,
  AccountInfoMetadata,
  EnterpriseCategoryCreatedEnvelope,
  EnterpriseCategoryDeletedEnvelope,
  EnterpriseCategoryUpdatedEnvelope,
  UpdateCategory,
  GetCategoryOptions,
  EnterpriseOnboardingOptions,
} from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.universal.js';
export {
  PublishStatusWithLiterals,
  MediaTypeWithLiterals,
  WebhookIdentityTypeWithLiterals,
} from './media-enterprise-public-media-v1-enterprise-category-enterprise-media-categories.universal.js';
